import React from 'react';
import './Modal.css'; // Import the CSS file for modal styling

const Modal = ({ isOpen, closeModal, children }) => {
  if (!isOpen) return null; // Don't render anything if the modal is not open

  return (
    <div className="modal">
        <div className="modal-content">
            <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
            </div>
        {/* <span className="close-btn" onClick={closeModal}>×</span> */}
        {children} {/* This will render whatever content is passed to the Modal */}
        </div>
    </div>
  );
};

export default Modal;
